import {
  PARTICIPANT_COMPLAINT_REASON_LABELS,
  TParticipantComplaintReason
} from '@/shared/constants';

import {
  formatActorComplaintReasonsSummary,
  getActorComplaintReasonLabel
} from './adminActorComplaint';

/**
 * Подпись причины жалобы на участника; неизвестный код показывается как есть
 * @param code - код причины
 */
export const getParticipantComplaintReasonLabel = (code: unknown): string =>
  typeof code === 'string'
    ? (PARTICIPANT_COMPLAINT_REASON_LABELS[
        code as TParticipantComplaintReason
      ] ?? code)
    : '—';

/**
 * «Причины» дела по жалобам на участника: «Это я, меня добавили без моего согласия ×2, Другое»
 * @param summary - `reasons_summary` бэка: `[{ reason, count }]`
 */
export const formatParticipantComplaintReasonsSummary = (summary: unknown) =>
  formatActorComplaintReasonsSummary(
    summary,
    getParticipantComplaintReasonLabel
  );

/**
 * Подпись причины жалобы любого раздела для общих ячеек списка, где раздел неизвестен:
 * коды жалоб на анкеты и на участников не пересекаются, кроме одинакового «Другое»
 * @param code - код причины
 */
export const getAnyComplaintReasonLabel = (code: string): string => {
  const participantLabel = getParticipantComplaintReasonLabel(code);

  return participantLabel === code
    ? getActorComplaintReasonLabel(code)
    : participantLabel;
};
